import { handleTrack } from '../../../../../../../utils/tracker';
import { Button, ButtonVariants } from '../../../../../../Atoms/Button';
import { SectionHeader } from '../../../../../../partner-pages/utils/section-header';
import { QUESTION } from '../../types';

interface IQNA_SECTION {
  currentQuestion: QUESTION;
  selectedAnswers: Record<string, string[]>;
  handleAnswerSelect: (
    questionId: string,
    answerId: string,
    isSingleSelect: boolean
  ) => void;
  handleBack: () => void;
  handleNext: () => void;
  currentQuestionIndex: number;
  currentStep: number;
}

export const QnASection = ({
  currentQuestion,
  selectedAnswers,
  handleAnswerSelect,
  handleBack,
  handleNext,
  currentQuestionIndex,
  currentStep,
}: IQNA_SECTION): JSX.Element => {
  const isNextDisabled = () =>
    !selectedAnswers[currentQuestion.id] ||
    selectedAnswers[currentQuestion.id]?.length === 0;

  const isBackDisabled = () => currentQuestionIndex === 0;

  const handleButtonClick = (
    e: React.MouseEvent | React.TouchEvent,
    goBack: boolean
  ) => {
    const button = e.target as HTMLButtonElement;
    handleTrack({
      label: `qna_modal_button_${button.textContent}_${currentStep}`,
      valueObj: selectedAnswers,
    });
    goBack ? handleBack() : handleNext();
  };
  return (
    <div className="relative h-[85vh]">
      <div className="flex justify-between">
        <SectionHeader
          heading={currentQuestion?.question}
          description={currentQuestion.desc}
          className="text-s-32 mb-2 sm:text-s-24"
          align="left"
        />
        <div className="text-font-200 text-s-14 absolute right-0">
          {`Step ${currentStep}/3`}
        </div>
      </div>
      <div className="h-[55vh] md:h-[60vh] md:pb-24  sm:h-3/4 overflow-y-scroll">
        <div
          className={`grid gap-4 ${
            currentQuestion.type === 'radio' ? 'grid-cols-1' : 'grid-cols-2'
          } md:grid-cols-1 sm:grid-cols-1 sm:pb-28 `}
        >
          {currentQuestion.answers.map((item) => {
            return (
              <div key={item.title}>
                <label
                  htmlFor={item.id}
                  className={`border  rounded-sm px-6 py-4 bg-white flex items-start gap-4 cursor-pointer hover:bg-[#EFF6FF] ${
                    selectedAnswers[currentQuestion.id]?.includes(item.id)
                      ? 'border-blue-350'
                      : 'border-grey-150'
                  }`}
                >
                  <div className="w-1/12">
                    <input
                      type={currentQuestion.type || 'checkbox'}
                      id={item.id}
                      name="question"
                      className="w-6 h-6 mt-2"
                      checked={
                        selectedAnswers[currentQuestion.id]?.includes(
                          item.id
                        ) || false
                      }
                      onChange={() =>
                        handleAnswerSelect(
                          currentQuestion.id,
                          item.id,
                          currentQuestion.type === 'radio'
                        )
                      }
                    />
                  </div>
                  <div className="w-11/12">
                    <div className="text-font-500 text-s-20 font-semibold mb-1">
                      {item.title}
                    </div>
                    <div
                      className={`text-base font-medium text-font-200 h-12 sm:h-auto ${
                        item.desc ? '' : 'hidden'
                      }`}
                    >
                      {item.desc}
                    </div>
                  </div>
                </label>
              </div>
            );
          })}
        </div>
      </div>

      <div className="absolute left-0 bottom-0 w-full sm:sticky bg-white">
        <div className="py-5 px-6 flex items-center justify-between mx-auto gap-10">
          <Button
            disabled={isBackDisabled()}
            onClick={(e) => handleButtonClick(e, true)}
            variant={ButtonVariants.bluebordered}
            className={`px-7 flex items-center gap-1 sm:w-full h-12 ${
              isBackDisabled() ? 'cursor-not-allowed opacity-50' : ''
            }`}
          >
            ← Back
          </Button>

          <Button
            disabled={isNextDisabled()}
            onClick={(e) => handleButtonClick(e, false)}
            variant={ButtonVariants.bluefilled}
            className={`px-7 flex items-center gap-1 sm:w-full h-12 ${
              isNextDisabled() ? 'cursor-not-allowed opacity-50' : ''
            }`}
          >
            Continue →
          </Button>
        </div>
      </div>
    </div>
  );
};
